<template>
  <div class="container d-flex py-5 main-container">
    <div class="my-auto w-100 main-area">
      <div class="registration-head text-center">
        <h1 class="rg-title">「Bloom キャリア登録」利用規約</h1>
      </div>
      <!-- ends-registration-head -->
      <div class="registration-detail-area">
        <p>株式会社Bloom（以下「当社」といいます。）が提供するキャリア登録システム「Bloom キャリア登録（以下「本サービス」といいます。）」の利用にあたっては、下記の利用規約（以下「本規約」といいます。）について承諾の上で登録・申し込みするものとします。</p>
          <h3 class="rg-title">第１条（適用）</h3>
          <p>本規約は、本サービスの提供条件及び本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。</p>

          <h3 class="rg-title">第２条（定義）</h3>
          <p>本規約において使用される各用語の定義は、以下に定めるとおりとします。</p>
          <p>①　ユーザー</p>
          <p>本サービスを利用している個人をいいます。    </p>
          <p>②　求人企業</p>
          <p>当社と契約を締結し、本サービスを利用して採用活動上の情報提供を行う企業をいいます。 </p>

          <h3 class="rg-title">第３条（サービスの提供）</h3>
          <p>1.　 当社は、本サービスにおいて、以下のサービスを提供するものとします。</p>
          <p>①　採用ポジション情報やイベント情報・企業情報等、採用活動に関する情報提供を希望した求人企業からの、登録した連絡先への情報提供・コミュニケーション</p>
          <p>②　求人企業の採用活動や就職・転職活動に関連する当社からの情報提供</p>
          <p>2. 　ユーザーは、本サービスの利用において、以下を承諾するものとします。</p>
          <p>①　情報提供を希望した求人企業および当社にてユーザーの登録情報の閲覧・保管を行うこと</p>
          <p>②　情報提供を希望した求人企業から、ユーザーが登録した連絡先へ直接連絡が行われること</p>
          <p>③　登録した全てのユーザーに情報提供されるわけではなく、登録した情報に基づき経験を活かせる可能性があるポジションや該当するイベントがあった際にのみ、情報提供が行われること</p>
          <p>④　ユーザーが求人企業から連絡を受けた以降、当該求人企業から当社に対し、ユーザーの転職活動の進捗状況（採否、および採用条件を含みます。）について報告を受けること</p>
          <p>⑤　本サービス退会後、求人企業が保有するユーザーの登録情報に基づき、ユーザーが登録した連絡先へ直接連絡が行われる場合があること</p>
          <p>⑥　求人企業から当社へ依頼がある場合、当社が本条に記載の内容を代行し、当社が求人企業の名義または当社名義でユーザーとの連絡を行う場合があること</p>
          <p>⑦　求人企業あるいは本サービスに関するアンケート調査を行うために、当社からユーザーに連絡を行う場合があること</p>

          <h3 class="rg-title">第４条（ユーザー登録及びユーザーの責任など）</h3>
          <p>1.　ユーザーは、自らの意思をもって本サービスに登録し、職務経歴などの登録情報はすべて、ユーザー自らがその内容の正確性・真実性・最新性等一切につき責任を負うものとします。</p>
          <p>2.　ユーザーが､本サービスに登録した登録情報等の全部または一部に誤りがあったために求人企業からクレームまたは登録情報等の削除依頼があった場合は､当社が事前の通知なしに当該登録情報等の全部または一部を削除することにつき、ユーザーはあらかじめ承諾するものとします｡</p>
          <p>3.　ユーザーが登録の抹消を行わない場合または抹消を希望しない場合であっても、ユーザー登録から1年経過した場合においては、データベース・メンテナンスの際にユーザー登録が抹消されることがあり、ユーザーはこれを承諾するものとします。</p>


          <h3 class="rg-title">第５条（パスワード及びユーザーＩＤの管理）</h3>
          <p>1.　ユーザーは、自己の責任において、本サービスに関するパスワード及びユーザーＩＤを適切に管理及び保管するものとし、これを第三者に利用させ、又は貸与、譲渡、名義変更、売買等をしてはならないものとします。</p>
          <p>2.　パスワード又はユーザーＩＤの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任はユーザーが負うものとし、当社は一切責任を負いません。</p>


          <h3 class="rg-title">第６条（禁止事項）</h3>
          <p>ユーザーは、以下の行為をしてはならないものとします。</p>
          <p>①　意図的に虚偽の情報を登録・提供する行為</p>
          <p>②　自己に関する情報ではない情報の登録・提供をする行為</p>
          <p>③　著作権、商標権、プライバシー権、氏名権、肖像権、名誉等の他人の権利を侵害する行為</p>
          <p>④ <span style="padding:5px;"></span> 個人や団体を誹謗中傷する行為</p>
          <p>⑤ <span style="padding:5px;"></span> 法令、公序良俗に反する行為、またはおそれのある行為</p>
          <p>⑥ <span style="padding:5px;"></span> 営利を目的とした登録・情報提供などの行為</p>
          <p>⑦ <span style="padding:5px;"></span> 当社または第三者に不利益を与える行為</p>
          <p>⑧ <span style="padding:5px;"></span> 前各号に該当するおそれのある行為</p>


          <h3 class="rg-title">第７条（個人情報の取扱い）</h3>
          <p>1.　当社は、当社のプライバシーポリシーに則りユーザーの個人情報を厳重かつ適正に取り扱うものとします。</p>
          <p>2.　求人企業における個人情報の取扱いについては当該企業ごとのプライバシーポリシーに則るものとします。</p>
          <p>3．当社が取得したユーザーの個人情報について当社が提携する求人企業に提供する場合、ユーザーの同意を得るものとします。</p>
          <p>4．当社は本サービスにおいて、当社のプライバシーポリシー記載のとおり、ユーザーの利便性向上のためGoogle, Inc.のGoogle Analyticsを利用してサイトの計測を行っております。その際、IPアドレス等のユーザー情報の一部（ユーザーを直接特定するような情報は含みません）がGoogle, Inc.に収集される可能性があります。ユーザーは以上の点について承諾したものとします。</p>


          <h3 class="rg-title">第８条（反社会的勢力等の排除）</h3>
          <p>1.　ユーザーは、現在および将来において、次の各号に掲げる事項を表明し保証するものとします。</p>
          <p>①　ユーザーが暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係者、総会屋その他の反社会的勢力（以下、総称して「反社会的勢力」という。）に該当しないこと</p>
          <p>②　ユーザーが、反社会的勢力に対して資金等を提供し、または便宜を供与し、もしくは便宜の供与を受ける等の関係を有していないこと</p>
          <p>③　前各号のほか、ユーザーが、反社会的勢力と関係を有することによって、社会的に非難されることがないこと</p>
          <p>2.　当社は、ユーザーが前項各号のいずれかに該当することが明らかになった場合には、通知をすることなく登録を解除することができるものとします。ただし、当社は、本項に基づく解除によりユーザーに生じた損害について賠償する責任を負わないものとし、当社に損害が生じた場合にはユーザーは損害を賠償しなければならないものとします。</p>

          <h3 class="rg-title">第９条（中断・終了）</h3>
           <p>1.　当社は、次の各号にいずれかに該当する場合は、ユーザーに何ら通知することなく本サービスの全部もしくは一部を変更し、または一時中断することがあります。また、一定期間の通知の上で、本サービスの全部または一部を終了することがあります。</p>
      　　 <p>①　本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</p>
      　　 <p>②　コンピューター、通信回線等が事故により停止した場合</p>
      　　 <p>③　地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</p>
          <p>④　その他、当社が停止または中断が事業運営上やむを得ないを判断した場合</p>
          <p>2.　当社は、本条に基づき当社が行った措置によってユーザーに生じた損害について一切責任を負いません。</p>


         <h3 class="rg-title">第１０条（登録解除）</h3>
         <p>当社は、次の各号にいずれかに該当する場合、通知をすることなく登録を解除し、ユーザーが登録したデータを抹消することができるものとします。</p>
          <p>①　本規約のいずれかの条項に違反した場合</p>
          <p>②　登録情報に虚偽の事実があることが判明した場合</p>
          <p>③　１年以上本サービスの利用がない場合</p>
          <p>④　当社からの問い合わせその他の回答を求める連絡に対して、１カ月以上応答がない場合</p>
          <p>⑤　その他、当社が本サービスの利用、ユーザーとして適当でないと判断した場合</p>

          <h3 class="rg-title">第１１条（退会）</h3>
          <p>1.　ユーザーは自らの意思によりいつでも、ユーザーログインページより本サービスを退会することができます。</p>
          <p>2.　退会に伴い、当社は、ユーザーの本サービスへの登録情報の全てを削除します。再度ユーザー登録をした場合においても、当社においては、退会前の情報を利用することはできません。</p>


        <h3 class="rg-title">第１２条（不保証）</h3>
        <p>1.　本サービスにおいて求人企業から提供される情報は当該情報を提供する者の責任で提供されるものであり、ユーザーは、提供情報の真実性、合法性、安全性、適切性、有用性について当社が何ら保証しないことを了承のうえ、自己の責任において利用するものとします。</p>
        <p>2.　ユーザーは、求人企業と登録情報の取扱い方や選考結果・労働条件等、本サービスの利用に伴い紛争が生じた場合には自己の責任と負担で当該紛争を直接求人企業と解決するものとし、当該紛争について当社は一切関与しないものとします。</p>


        <h3 class="rg-title">第１３条（本サービスの内容の変更、終了）</h3>
        <p>1.　当社は、当社の都合により、本サービスの内容を変更し、又は提供を終了することができます。</p>
        <p>2.　当社は本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</p>

        <h3 class="rg-title">第１４条（損害賠償責任）</h3>
        <p>ユーザーが本規約の各事項に違反して、当社、関係者または第三者に損害を与えた場合は、ユーザーはその損害を賠償するものとします。</p>

        <h3 class="rg-title">第１５条（損害賠償責任の限定）</h3>
        <p>1.　当社は、本サービスの利用から生じたユーザーの損害については何らの責任も負わないものとします。</p>
        <p>2.　前項の規定にかかわらず、当社の債務不履行又は不法行為によりユーザーに損害を生じさせた場合、当社はユーザーに対し、当該損害のうち直接かつ現実の通常損害に限り、賠償の責任を負うものとします。</p>

        <h3 class="rg-title">第１６条（本規約の変更）</h3>
        <p>当社は、必要に応じて本規約の内容を変更することができるものとします。変更後の本規約の内容は、本サービスにおいて掲載するものとし、掲載後1カ月経過後に本サービスを継続して利用しているユーザーは、変更後の本規約の内容に同意したものとみなします。</p>

        <h3 class="rg-title">第１７条（本サービス利用契約上の地位の譲渡）</h3>
        <p>当社は本サービスにかかる事業を他者に譲渡した場合にいは、当該事業譲渡に伴いサービス利用契約上の地位、本規約に基づく権利及び義務並びにユーザーの登録事項を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡について予め同意したものとします。なお、本条に定める事業譲渡には、会社分割その他事業が移転するあらゆる場合を含むものとします。</p>

        <h3 class="rg-title">第１８条（管轄裁判所）</h3>
        <p>本規約の各事項に関連して紛争が生じた場合は、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>

        <h3 class="rg-title">附則</h3>
          <p>2018年7月24日 制定・施行</p>
          <p>2019年5月21日 改訂</p>
          <p>2020年6月4日 改訂</p>


      </div>
      <!--ends registration-detail-area -->
      <div class="reg-footer">
        <div class="site-title-custom">
          <a href="https://www.blm.co.jp/" target="_blank">© Bloom Inc.</a>
        </div>
      </div>
      <!-- ends reg-footer -->
    </div>
    <!-- ends main-area -->
  </div>
</template>
<script>
export default {
  name: 'Agreement',
  data() {
    return {};
  },
};
</script>
<style scoped>
.logo {
  position: absolute;
  left: 20px;
  z-index: 99;
  bottom: 27px;
}

.logo img {
  max-height: 35px;
}

.main-container {
  padding-bottom: 70px !important;
}
.textLink {
  position: absolute;
  bottom: 7px;
  left: 20px;
  z-index: 99;
}
.heading{
  font-weight: bold;
}

.textLink a {
  font-family: 游ゴシック, YuGothic, メイリオ, Meiryo, Helvetica, Arial,
    sans-serif;
  color: #435b67;
  font-size: 10px;
  font-weight: bold;
}
.warning-notice {
  text-align: center;
  padding-top: 25px;
  /* color: grey; */
}
p{
  white-space: pre-line;
}
.registration-head{
  background-color: #036d6c;
  height: -moz-fit-content;
  height: fit-content;
}

.registration-head {
  height: -moz-fit-content !important;
  height: fit-content !important;
}
</style>

